<template>
  <div :class="menuClass + ' custom-container'">
    <div v-if="loader" class="loading-layout">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else class="profil page-wrapp">
      <v-row>
        <v-col
          :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
          :class="
            !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
          "
        >
          <v-row class="align-center">
            <v-col v-on:click="goToLink('#/profil')" cols="1">
              <v-btn elevation="2" icon
                ><v-icon>mdi-chevron-left</v-icon></v-btn
              >
            </v-col>
            <v-col cols="11">
              <v-card-title>Mine avtaler</v-card-title>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <template v-if="accounts && accounts.length > 1">
        <v-row class="justify-center">
          <v-col>
            <v-row class="align-center">
              <v-col
                class="pb-0 mb-3"
                :cols="!$vuetify.breakpoint.smAndDown ? 12 : 12"
              >
                <v-select
                  v-model="selectAccount"
                  :items="selectItems"
                  item-text="label"
                  item-value="value"
                  label="Dine kontoer"
                  outlined
                  v-on:change="changeAccount"
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-else> </template>
      <v-row class="justify-center">
        <v-col
          :class="
            !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
          "
        >
          <div
            v-for="(account, index) in selectedAccount"
            :key="account.Guid"
            class="mt-2 mb-12"
          >
            <div class="d-flex justify-start">
              <div>
                <v-card-title class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0">{{
                  account.Name || "Konto " + index
                }}</v-card-title>
              </div>
              <div class="ml-3">
                <v-icon
                  v-on:click="goToLink('#/profil/contact/' + account.Guid)"
                  >mdi-pencil-outline</v-icon
                >
              </div>
            </div>
            <div class="contract-products">
              <v-card
                v-for="contract in selectedContracts[account.Guid]"
                :key="contract.id"
                class="item-content primaty-item"
                elevation="2"
              >
                <div class="theme--light power-label">Strømavtale</div>

                <div class="product-img">
                  <v-avatar color="primary" size="48">
                    <v-icon class="white--text">mdi-lightning-bolt</v-icon>
                  </v-avatar>
                </div>

                <div class="product-info">
                  <p class="name">{{ contract.name }}</p>
                  <div class="description">
                    {{ contract.description ? contract.description : "" }}
                  </div>
                </div>

                <div class="product-details">
                  <div class="addres">{{ contract.address }}</div>
                  <div class="id">{{ contract.id }}</div>
                </div>

                <div
                  v-if="contract.UpcomingProductChange"
                  class="upcomming-changes"
                >
                  <v-alert
                    text
                    dense
                    color="primary"
                    icon="mdi-clock-fast"
                    border="left"
                  >
                    {{
                      $moment(contract.UpcomingProductChange.StartDate).format(
                        "DD"
                      )
                    }}.
                    {{
                      getNorwayMonth(
                        new Date(
                          contract.UpcomingProductChange.StartDate
                        ).getMonth()
                      )
                    }}
                    {{
                      $moment(contract.UpcomingProductChange.StartDate).format(
                        "YYYY"
                      )
                    }}<span> blir avtalen endret til </span>
                    {{ contract.UpcomingProductChange.Products[0].ProductName }}
                  </v-alert>
                </div>

                <v-btn
                  text
                  class="edit-btn"
                  link
                  v-on:click="goToLink('#/forbruk/' + contract.guid)"
                  >Se forbruk</v-btn
                >
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar">
        {{ snackbarText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" v-on:click="snackbar = false">
            Lukke
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { getNorwayMonth } from "../../utils/date";
import { account, accountingPoints } from "../../api/common";

import "./Profil.scss";

export default {
  name: "ContractInformation",

  components: {},

  data() {
    return {
      loader: false,
      menuClass: "",
      selectAccount: "",
      selectItems: [],
      selectedAccount: [],
      selectedContracts: {},
      accounts: [],
      snackbar: false,
      snackbarText: "",
      contracts: {},
    };
  },

  async mounted() {
    await this.getDataFromApi();

    if (localStorage.tenant === "9876543210517") {
      this.menuClass = "sokrates";
    } else if (localStorage.tenant === "7080010002488") {
      this.menuClass = "klark";
    } else {
      this.menuClass = "hks";
    }
  },

  methods: {
    async getDataFromApi() {
      this.loader = true;
      this.selectItems = [{ label: "Se alle", value: "" }];
      this.selectAccount = "";
      this.accounts = [];
      this.contracts = {};

      try {
        let tmpAccounts = await account();
        tmpAccounts = tmpAccounts.data.Accounts;

        tmpAccounts.forEach((item) => {
          this.selectItems.push({
            label: item.Name || "Konto",
            value: item.Guid,
          });
          this.accounts.push(this.decorateAccount(item));
        });

        let tmpContracts = await accountingPoints();
        tmpContracts = tmpContracts.data.AccountingPoints;

        tmpContracts
          .filter((item) => item.Status === "Active")
          .forEach((item) => {
            if (!this.contracts[item.AccountGuid])
              this.contracts[item.AccountGuid] = [];
            this.contracts[item.AccountGuid].push(this.decorateContract(item));
          });

        console.log(tmpContracts);
        console.log(this.contracts);

        this.changeAccount();
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = "Feil ved innlasting av data ";
      }

      this.loader = false;
    },

    changeAccount() {
      if (this.selectAccount) {
        let tmp = this.accounts.filter(
          (item) => item.Guid == this.selectAccount
        );
        tmp = tmp && tmp.length > 0 ? [tmp[0]] : this.accounts;

        this.selectedAccount = [];
        this.selectedAccount = [...tmp];
      } else {
        this.selectedAccount = [];
        this.selectedAccount = [...this.accounts];
      }

      this.selectedContracts = [];
      for (let key in this.contracts) {
        if (this.selectedAccount.filter((item) => item.Guid == key).length > 0)
          this.selectedContracts[key] = [...this.contracts[key]];
      }
    },

    decorateAccount(item) {
      let decoratedAccount = Object.assign({}, item);
      decoratedAccount.mobile = (item.Communication.filter(
        (com) => com.Channel == "Mobile"
      ) || [{ Value: "" }])[0].Value;
      decoratedAccount.email = (item.Communication.filter(
        (com) => com.Channel == "Email"
      ) || [{ Value: "" }])[0].Value;
      decoratedAccount.address = (item.Addresses || [{}])[0];
      return decoratedAccount;
    },

    decorateContract(item) {
      let decoratedContract = {
        name: "",
        id: "",
        address: "",
        UpcomingProductChange: "",
        guid: "",
      };

      if (item.UpcomingProductChange) {
        decoratedContract.UpcomingProductChange = item.UpcomingProductChange;
      }

      let primaryProduct = item.Products.find((subitem) => {
        return subitem.PrimaryProduct;
      });

      if (primaryProduct) {
        decoratedContract.name = primaryProduct.ProductName;
      }

      if (item.Address) {
        decoratedContract.address =
          item.Address.StreetName +
          " " +
          item.Address.BuildingNumber +
          ", " +
          item.Address.PostCode +
          " " +
          item.Address.CityName;
      }

      if (item.AccountingPointIdentification) {
        decoratedContract.id = item.AccountingPointIdentification;
      }

      if (item.AccountingPointGuid) {
        decoratedContract.guid = item.AccountingPointGuid;
      }

      return decoratedContract;
    },

    goToLink(route) {
      let tmp = document.createElement("a");
      tmp.href = route;
      tmp.click();
    },

    getNorwayMonth(month) {
      return getNorwayMonth(month);
    },
  },
};
</script>
